var env = "local";
var configData = null;

// var localConfig = {
//     gameAPI: "http://192.168.5.64:5050/party/",
//     serviceAPI: "http://192.168.5.64:5050/service/",
//     agentKey: "frank001",
//     domain: "01.com",
//     lineUrl: "http://192.168.5.228:88/lines.json",
//     // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
//     merchantCode: "5ea88d07eb2347a0b1836af413be7f03",
//     gameWebUrl: "http://192.168.5.228:81/",
//     games: [
//         { gameCode: '1001', gameName: "财神到", version: '20aad0b2' },
//         { gameCode: '1002', gameName: "盗墓笔记", version: 'b8ab821c' },
//         { gameCode: '1003', gameName: "燃爆嘻哈夜", version: 'a9beba50' },
//         { gameCode: '1004', gameName: "三倍泰山", version: '73ad0697' },
//         { gameCode: '1005', gameName: "火焰777", version: 'a90ff2dc' },
//         { gameCode: '1006', gameName: "魔童哪吒", version: 'f46ccfe8' },
//         { gameCode: '1007', gameName: "足球风云", version: '51d66c28' },
//         { gameCode: '1008', gameName: "五龙吐珠", version: '1c1bfdcb' },
//         { gameCode: '2001', gameName: "捕鱼来了", version: '56e3846d' },
//         { gameCode: '3003', gameName: "通比牛牛", version: '56e3846d' },
//         { gameCode: '4001', gameName: "禁抢红包", version: '56e3846d' },
//     ],
//     showGameList: true,
//     envName:"local"
// }




var devConfig = {
  gameAPI: "http://192.168.5.211:8080/party/",
  serviceAPI: "http://192.168.5.211:8080/service/",
  agentKey: "dev003",
  domain: "1.com",
  frontendAPI: "",
  lineUrl: "http://192.168.5.211:88/lines.json",
  // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
  merchantCode: "19fac377b23049ba87fa010382a084d8",
  gameWebUrl: "http://192.168.5.211:81/",
  showGameList: true,
  envName: "dev",
  currentLang: "zh-CN",
  currentCurrency: "RMB",
  merchantCodeCN: "19fac377b23049ba87fa010382a084d8",
  agentKeyCN: "dev003",
  domainCN: "1.com",
  merchantCodeTH: "49f141628e994baf85c8b735252b8485",
  agentKeyTH: "thai003",
  domainTH: "1.thai",
  merchantCodeEN: "79ad9956ea3a461ca2c8fcd802e0f95f",
  agentKeyEN: "deven03",
  domainEN: "1.en",
  merchantCodeVI: "34b0fb7d568a4116bffe0a18c30095e6",
  agentKeyVI: "devvi003",
  domainVI: "1.vi",
  merchantCodeTW: "0f51b508314e4d72b360b24b43d35e13",
  agentKeyTW: "devtw003",
  domainTW: "1.tw",
  merchantCodePHP: "1b1bfe115ccd4b429c98a1c39a8d1724",
  agentKeyPHP: "devphp003",
  domainPHP: "1.php",
  merchantCodeZMW: "e4cf027b5d99464681cfbceba20f8361",
  agentKeyZMW: "devzmw003",
  domainZMW: "1.zmw",
  merchantCodeTZS: "e6d79edc20304729b04266aadb31b258",
  agentKeyTZS: "devtzs003",
  domainTZS: "1.tzs",
  merchantCodeKES: "33f5a43c13ea4d849a82a3ec33fbbf46",
  agentKeyKES: "devkes003",
  domainKES: "1.kes",
  merchantCodeNGN: "06c63cc058a7444f9e0f7177dce1146e",
  agentKeyNGN: "devngn003",
  domainNGN: "1.ngn",
  merchantCodeBRL: "7657c4dcb6a645ea849a6e8957154a64",
  agentKeyBRL: "devbrl003",
  domainBRL: "1.brl",
  merchantCodeJPY: "dbd80a115e4c4a5c87f09c0dd1e676d7",
  agentKeyJPY: "devjpy003",
  domainJPY: "1.jpy",
  playgameSetting: {
    "RMB": {
      merchantCode: "19fac377b23049ba87fa010382a084d8",
      agentKey: "dev003",
      domain: "1.com",
    },
    "THB": {
      merchantCode: "49f141628e994baf85c8b735252b8485",
      agentKey: "thai003",
      domain: "1.thai",
    },
    "USD": {
      merchantCode: "79ad9956ea3a461ca2c8fcd802e0f95f",
      agentKey: "deven03",
      domain: "1.en",
    },
    "VND": {
      merchantCode: "34b0fb7d568a4116bffe0a18c30095e6",
      agentKey: "devvi003",
      domain: "1.vi",
    },
    "NTD": {
      merchantCode: "0f51b508314e4d72b360b24b43d35e13",
      agentKey: "devtw003",
      domain: "1.tw",
    },
    "PHP": {
      merchantCode: "1b1bfe115ccd4b429c98a1c39a8d1724",
      agentKey: "devphp003",
      domain: "1.php",
    },
    "ZMW": {
      merchantCode: "e4cf027b5d99464681cfbceba20f8361",
      agentKey: "devzmw003",
      domain: "1.zmw",
    },
    "TZS": {
      merchantCode: "e6d79edc20304729b04266aadb31b258",
      agentKey: "devtzs003",
      domain: "1.tzs",
    },
    "KES": {
      merchantCode: "33f5a43c13ea4d849a82a3ec33fbbf46",
      agentKey: "devkes003",
      domain: "1.kes",
    },
    "NGN": {
      merchantCode: "06c63cc058a7444f9e0f7177dce1146e",
      agentKey: "devngn003",
      domain: "1.ngn",
    },
    "BRL": {
      merchantCode: "7657c4dcb6a645ea849a6e8957154a64",
      agentKey: "devbrl003",
      domain: "1.brl",
    },
    "JPY": {
      merchantCode: "dbd80a115e4c4a5c87f09c0dd1e676d7",
      agentKey: "devjpy003",
      domain: "1.jpy",
    },
    "MYR": {
      merchantCode: "c3d5362b5c6344779adf268e0df3df48",
      agentKey: "devmyr003",
      domain: "1.myr",
    },
    "BDT": {
      merchantCode: "5ec71e663dcb420e894b61ce499a6ec6",
      agentKey: "devbdt003",
      domain: "1.bdt",
    },
    "IDR": {
      merchantCode: "7adb0834191b46c193ff39d946298a81",
      agentKey: "devidr003",
      domain: "1.idr",
    },
    "KRW": {
      merchantCode: "8d5a815745944cd48c4c811b7777126a",
      agentKey: "devkrw003",
      domain: "1.krw",
    },
    "MXN": {
      merchantCode: "9f24f893855d4a9ba5f62bdde3018e6a",
      agentKey: "devmxn003",
      domain: "1.mxn",
    },
    "ARS": {
      merchantCode: "957745a38de54723acd6d758b604cc2d",
      agentKey: "devars003",
      domain: "1.ars",
    },
    "INR": {
      merchantCode: "33587333db2f4d1bb8daf23d66871489",
      agentKey: "devinr003",
      domain: "1.inr",
    },
    "RUB": {
      merchantCode: "6f52c5f0c4704a6993bf596ca8dda72d",
      agentKey: "devrub003",
      domain: "1.rub",
    },
    "TRY": {
      merchantCode: "9d7949406e5a4dbfbe0d0d305148adca",
      agentKey: "devtry003",
      domain: "1.try",
    },
    "HKD": {
      merchantCode: "3072594b28eb4ff0bbde11ebeda72477",
      agentKey: "devhkd003",
      domain: "1.hkd",
    },
    "PKR": {
       merchantCode: "8e91609e159740c797a6429decc157ae",
      agentKey: "devpkr003",
      domain: "1.pkr",
    },
    "EGP": {
       merchantCode: "2f638ef21121409c95aca64348df7726",
      agentKey: "devegp003",
      domain: "1.egp",
    },
    "ZAR": {
       merchantCode: "5bbc48b65a2e474e8e6e5c4a343a9909",
      agentKey: "devzar003",
      domain: "1.zar",
    },
    "NTA": {
       merchantCode: "cf73213c2f874cfd983d2b4222a5a25a",
      agentKey: "dev100ntd003",
      domain: "1.100ntd",
    },
    "NTB": {
       merchantCode: "0129b2b653a94256870b00aef0cf2140",
      agentKey: "dev10kntd003",
      domain: "1.10kntd",
    }
  },

}
var qcConfig = {
  gameAPI: "http://192.168.5.216:8080/party/",
  serviceAPI: "http://192.168.5.216:8080/service/",
  agentKey: "dev003",
  domain: "1.com",
  frontendAPI: "",
  lineUrl: "http://192.168.5.216:88/lines.json",
  // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
  merchantCode: "19fac377b23049ba87fa010382a084d8",
  gameWebUrl: "http://192.168.5.216:81/",
  showGameList: true,
  envName: "qc",
  currentLang: "zh-CN",
  currentCurrency: "RMB",
  merchantCodeCN: "19fac377b23049ba87fa010382a084d8",
  agentKeyCN: "dev003",
  domainCN: "1.com",
  playgameSetting: {
    "RMB": {
      merchantCode: "19fac377b23049ba87fa010382a084d8",
      agentKey: "dev003",
      domain: "1.com",
    },
    "THB": {
      merchantCode: "0bad644d217543f2a6b46eb0ce170159",
      agentKey: "thai003",
      domain: "1.thai",
    },
    "USD": {
      merchantCode: "157d76ba5d2e4e1485f1809dc7023d02",
      agentKey: "deven03",
      domain: "1.en",
    },
    "VND": {
      merchantCode: "687c7f660f2249b4ba1d546b6d32d96b",
      agentKey: "devvi003",
      domain: "1.vi",
    },
    "NTD": {
      merchantCode: "acac3bd3a9a5437a93df27404b9fe9da",
      agentKey: "devtw003",
      domain: "1.tw",
    },
    "PHP": {
      merchantCode: "ca41088c4e7e43958faae4b6d034c3a3",
      agentKey: "devphp003",
      domain: "1.php",
    },
    "ZMW": {
      merchantCode: "86e5cd84cb7f42c89218bf43e8d7b543",
      agentKey: "devzmw003",
      domain: "1.zmw",
    },
    "TZS": {
      merchantCode: "88363ab8796049d1b95f315f36a585cf",
      agentKey: "devtzs003",
      domain: "1.tzs",
    },
    "KES": {
      merchantCode: "eb61acd8dd3343c79673b3e55bfcea2f",
      agentKey: "devkes003",
      domain: "1.kes",
    },
    "NGN": {
      merchantCode: "bf0dc549bdf747e6a0633fc9a7568c80",
      agentKey: "devngn003",
      domain: "1.ngn",
    },
    "BRL": {
      merchantCode: "06eb5eb9626f44649df48510e67c2294",
      agentKey: "devbrl003",
      domain: "1.brl",
    },
    "JPY": {
      merchantCode: "6f62d4a14766431abc01732bc187315f",
      agentKey: "devjpy003",
      domain: "1.jpy",
    },
    "MYR": {
      merchantCode: "b07cc074cef54bfcb112a9a362ee5ec1",
      agentKey: "devmyr003",
      domain: "1.myr",
    },
    "BDT": {
      merchantCode: "ba643ab0818149a295b3a37890675801",
      agentKey: "devbdt003",
      domain: "1.bdt",
    },
    "IDR": {
      merchantCode: "70a86bd8ddd14f7499174aa307d2faad",
      agentKey: "devidr003",
      domain: "1.idr",
    },
    "KRW": {
      merchantCode: "6d75865688f64aa59530ace1f14c3dbf",
      agentKey: "devkrw003",
      domain: "1.krw",
    },
    "MXN": {
      merchantCode: "fe6597d9d3ef4b33bdf8997480697e77",
      agentKey: "devmxn003",
      domain: "1.mxn",
    },
    "ARS": {
      merchantCode: "8930ee13300444bcb3dd94fdae14682c",
      agentKey: "devars003",
      domain: "1.ars",
    },
    "INR": {
      merchantCode: "12454d1eb2654673bc71cc3974e3e06d",
      agentKey: "devinr003",
      domain: "1.inr",
    },
    "RUB": {
      merchantCode: "8c5ec33d25bd4ce1ba33afee6d7fe81f",
      agentKey: "devrub003",
      domain: "1.rub",
    },
    "TRY": {
      merchantCode: "52f73faa069645ae9b5b73e0016bb2b1",
      agentKey: "devtry003",
      domain: "1.try",
    },
    "PKR": {
       merchantCode: "8e91609e159740c797a6429decc157ae",
      agentKey: "devpkr003",
      domain: "1.pkr",
    },
    "EGP": {
       merchantCode: "2f638ef21121409c95aca64348df7726",
      agentKey: "devegp003",
      domain: "1.egp",
    },
    "ZAR": {
       merchantCode: "5bbc48b65a2e474e8e6e5c4a343a9909",
      agentKey: "devzar003",
      domain: "1.zar",
    },
    "NTA": {
       merchantCode: "cf73213c2f874cfd983d2b4222a5a25a",
      agentKey: "dev100ntd003",
      domain: "1.100ntd",
    },
    "NTB": {
       merchantCode: "0129b2b653a94256870b00aef0cf2140",
      agentKey: "dev10kntd003",
      domain: "1.10kntd",
    }
  },
  merchantCodeTH: "0bad644d217543f2a6b46eb0ce170159",
  agentKeyTH: "thai003",
  domainTH: "1.thai",
  merchantCodeEN: "157d76ba5d2e4e1485f1809dc7023d02",
  agentKeyEN: "deven03",
  domainEN: "1.en",
  merchantCodeVI: "687c7f660f2249b4ba1d546b6d32d96b",
  agentKeyVI: "devvi003",
  domainVI: "1.vi",
  merchantCodeTW: "acac3bd3a9a5437a93df27404b9fe9da",
  agentKeyTW: "devtw003",
  domainTW: "1.tw",
  merchantCodePHP: "ca41088c4e7e43958faae4b6d034c3a3",
  agentKeyPHP: "devphp003",
  domainPHP: "1.php",
  merchantCodeZMW: "86e5cd84cb7f42c89218bf43e8d7b543",
  agentKeyZMW: "devzmw003",
  domainZMW: "1.zmw",
  merchantCodeTZS: "88363ab8796049d1b95f315f36a585cf",
  agentKeyTZS: "devtzs003",
  domainTZS: "1.tzs",
  merchantCodeKES: "eb61acd8dd3343c79673b3e55bfcea2f",
  agentKeyKES: "devkes003",
  domainKES: "1.kes",
  merchantCodeNGN: "bf0dc549bdf747e6a0633fc9a7568c80",
  agentKeyNGN: "devngn003",
  domainNGN: "1.ngn",
  merchantCodeBRL: "06eb5eb9626f44649df48510e67c2294",
  agentKeyBRL: "devbrl003",
  domainBRL: "1.brl",
  merchantCodeJPY: "6f62d4a14766431abc01732bc187315f",
  agentKeyJPY: "devjpy003",
  domainJPY: "1.jpy",
}
// var demositeConfig = {
//     gameAPI: "https://api.tiangeo.com/party/",
//     serviceAPI: "https://api.tiangeo.com/service/",
//     agentKey: "frank001",
//     domain: "01.com",
//     frontendAPI: "",
//     lineUrl: "https://sl.tiangeo.com/lines.json",
//     // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
//     merchantCode: "5ea88d07eb2347a0b1836af413be7f03",
//     gameWebUrl: "https://gameweb.tiangeo.com/",
//     showGameList: true,
//     envName: "demosite"
// }

const tiangeo168LinesUrl = "https://staging.tiangeo168.com/lines168.json";

var demositeConfig = {
  gameAPI: "https://api.tiangeo888.com/party/",
  serviceAPI: "https://api.tiangeo888.com/service/",
  agentKey: "dev3001",
  domain: "dev001",
  frontendAPI: "",
  lineUrl: "https://game.tiangeo888.com/lines.json",
  // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
  merchantCode: "873e89f98d9c4523b36b34a22898595f",
  gameWebUrl: "https://gameweb.tjgame888.com/",
  showGameList: true,
  envName: "demosite",
  currentLang: "zh-CN",
  currentCurrency: "RMB",
  merchantCodeCN: "873e89f98d9c4523b36b34a22898595f",
  agentKeyCN: "dev3001",
  domainCN: "dev001",
  merchantCodeTH: "155f5a9dacc84f2b930c991ff123c3e2",
  agentKeyTH: "thai003",
  domainTH: "1.thai",
  merchantCodeEN: "219ad8443a404b80ba32188b8e130c60",
  agentKeyEN: "deven03",
  domainEN: "1.en",
  merchantCodeVI: "16d38ab8e70d4cfea7a257db90149c9d",
  agentKeyVI: "devvi003",
  domainVI: "1.vi",
  merchantCodeTW: "369a796e269a4b499698111458d63e85",
  agentKeyTW: "devtw003",
  domainTW: "1.tw",
  merchantCodePHP: "8b3cce5749264ef69af7423eb8c54a29",
  agentKeyPHP: "devphp003",
  domainPHP: "1.php",
  merchantCodeZMW: "02701bd72c5a4c9cb8f387d7877a6137",
  agentKeyZMW: "devzmw003",
  domainZMW: "1.zmw",
  merchantCodeTZS: "fcbe6a06b1fd49079a4965ca2b785e17",
  agentKeyTZS: "devtzs003",
  domainTZS: "1.tzs",
  merchantCodeKES: "9975333867cb454ebaa303cea9323a61",
  agentKeyKES: "devkes003",
  domainKES: "1.kes",
  merchantCodeNGN: "5011c511eebb49a699f3ee6b04500b10",
  agentKeyNGN: "devngn003",
  domainNGN: "1.ngn",
  merchantCodeBRL: "849c70918b5c480a8e01860908af1966",
  agentKeyBRL: "devbrl003",
  domainBRL: "1.brl",
  merchantCodeJPY: "708b1028dde74ed5afe2e2e9079e7b72",
  agentKeyJPY: "devjpy003",
  domainJPY: "1.jpy",
  playgameSetting: {
    "RMB": {
      merchantCode: "873e89f98d9c4523b36b34a22898595f",
      agentKey: "dev3001",
      domain: "dev001",
    },
    "THB": {
      merchantCode: "155f5a9dacc84f2b930c991ff123c3e2",
      agentKey: "thai003",
      domain: "1.thai",
    },
    "USD": {
      merchantCode: "219ad8443a404b80ba32188b8e130c60",
      agentKey: "deven03",
      domain: "1.en",
    },
    "VND": {
      merchantCode: "16d38ab8e70d4cfea7a257db90149c9d",
      agentKey: "devvi003",
      domain: "1.vi",
    },
    "NTD": {
      merchantCode: "369a796e269a4b499698111458d63e85",
      agentKey: "devtw003",
      domain: "1.tw",
    },
    "PHP": {
      merchantCode: "8b3cce5749264ef69af7423eb8c54a29",
      agentKey: "devphp003",
      domain: "1.php",
    },
    "ZMW": {
      merchantCode: "02701bd72c5a4c9cb8f387d7877a6137",
      agentKey: "devzmw003",
      domain: "1.zmw",
    },
    "TZS": {
      merchantCode: "fcbe6a06b1fd49079a4965ca2b785e17",
      agentKey: "devtzs003",
      domain: "1.tzs",
    },
    "KES": {
      merchantCode: "9975333867cb454ebaa303cea9323a61",
      agentKey: "devkes003",
      domain: "1.kes",
    },
    "NGN": {
      merchantCode: "5011c511eebb49a699f3ee6b04500b10",
      agentKey: "devngn003",
      domain: "1.ngn",
    },
    "BRL": {
      merchantCode: "849c70918b5c480a8e01860908af1966",
      agentKey: "devbrl003",
      domain: "1.brl",
    },
    "JPY": {
      merchantCode: "708b1028dde74ed5afe2e2e9079e7b72",
      agentKey: "devjpy003",
      domain: "1.jpy",
    },
    "MYR": {
      merchantCode: "2d759be4b48c4093b1a4a8151fd16aaf",
      agentKey: "devmyr003",
      domain: "1.myr",
    },
    "BDT": {
      merchantCode: "ab9547709a594ab2bbafb3acd8508cef",
      agentKey: "devbdt003",
      domain: "1.bdt",
    },
    "IDR": {
      merchantCode: "7b62ef710c7348c78fd868909341d321",
      agentKey: "devidr003",
      domain: "1.idr",
    },
    "KRW": {
      merchantCode: "f6612a2fff7d44b58943f5ada28f5c66",
      agentKey: "devkrw003",
      domain: "1.krw",
    },
    "MXN": {
      merchantCode: "e5217b29b39d46a8b4ce76b542410f73",
      agentKey: "devmxn003",
      domain: "1.mxn",
    },
    "ARS": {
      merchantCode: "d297165c875849fa837e1000dba7907e",
      agentKey: "devars003",
      domain: "1.ars",
    },
    "INR": {
      merchantCode: "a11995adcdce4d868dc6276f0ad91421",
      agentKey: "devinr003",
      domain: "1.inr",
    },
    "RUB": {
      merchantCode: "d5f5573799924cc38960400e9389309c",
      agentKey: "devrub003",
      domain: "1.rub",
    },
    "TRY": {
      merchantCode: "6f3b94b917934d50b9cd1a4254f1116c",
      agentKey: "devtry003",
      domain: "1.try",
    },
    "PKR": {
       merchantCode: "ae9cbb6c72d34a61b43aeaaad18fca5d",
      agentKey: "devpkr003",
      domain: "1.pkr",
    },
    "EGP": {
       merchantCode: "40550607d27745b1b6d7962d55fe21a0",
      agentKey: "devegp003",
      domain: "1.egp",
    },
    "ZAR": {
       merchantCode: "ed3d5cffdd28460285d3851d71539a10",
      agentKey: "devzar003",
      domain: "1.zar",
    },
    "NTA": {
       merchantCode: "1f083f5b68604a93bea263bc5463bc95",
      agentKey: "dev100ntd003",
      domain: "1.100ntd",
    },
    "NTB": {
       merchantCode: "a1717514968c459aa042d1b4ddaabd3e",
      agentKey: "dev10kntd003",
      domain: "1.10kntd",
    }
  },
}
// var stressConfig = {
//     gameAPI: "https://api.tiangeo888.com/party/",
//     serviceAPI: "https://api.tiangeo888.com/service/",
//     agentKey: "",
//     domain: "",
//     frontendAPI: "",
//     lineUrl: "https://sl.tiangeo888.com/lines.json",
//     // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
//     merchantCode: "",
//     gameWebUrl: "https://gameweb.tiangeo888.com/",
//     games: [
//         { gameCode: '1001', gameName: "财神到", version: 'de93031c' },
//         { gameCode: '1002', gameName: "盗墓笔记", version: 'b8ab821c' },
//         { gameCode: '1003', gameName: "燃爆嘻哈夜", version: 'a9beba50' },
//         { gameCode: '1004', gameName: "三倍泰山", version: '73ad0697' },
//         { gameCode: '1005', gameName: "火焰777", version: 'a90ff2dc' },
//         { gameCode: '1006', gameName: "魔童哪吒", version: 'f46ccfe8' },
//         { gameCode: '1007', gameName: "足球风云", version: '51d66c28' },
//         { gameCode: '1008', gameName: "五龙吐珠", version: '1c1bfdcb' },
//         { gameCode: '2001', gameName: "捕鱼来了", version: '56e3846d' },
//     ],
//     showGameList: true,
//     envName: "stress"
// }


var stagingConfig = {
  gameAPI: "https://api.tiangeo888.com/party/",
  serviceAPI: "https://api.tiangeo888.com/service/",
  agentKey: "dev3001",
  domain: "dev001",
  frontendAPI: "",
  lineUrl: "https://game.tiangeo888.com/lines.json",
  // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
  merchantCode: "873e89f98d9c4523b36b34a22898595f",
  gameWebUrl: "https://gameweb.tjgame888.com/",
  showGameList: true,
  envName: "demosite",
  currentLang: "zh-CN",
  currentCurrency: "RMB",
  merchantCodeCN: "873e89f98d9c4523b36b34a22898595f",
  agentKeyCN: "dev3001",
  domainCN: "dev001",
  merchantCodeTH: "155f5a9dacc84f2b930c991ff123c3e2",
  agentKeyTH: "thai003",
  domainTH: "1.thai",
  merchantCodeEN: "219ad8443a404b80ba32188b8e130c60",
  agentKeyEN: "deven03",
  domainEN: "1.en",
  merchantCodeVI: "16d38ab8e70d4cfea7a257db90149c9d",
  agentKeyVI: "devvi003",
  domainVI: "1.vi",
  merchantCodeTW: "369a796e269a4b499698111458d63e85",
  agentKeyTW: "devtw003",
  domainTW: "1.tw",
  merchantCodePHP: "8b3cce5749264ef69af7423eb8c54a29",
  agentKeyPHP: "devphp003",
  domainPHP: "1.php",
  merchantCodeZMW: "02701bd72c5a4c9cb8f387d7877a6137",
  agentKeyZMW: "devzmw003",
  domainZMW: "1.zmw",
  merchantCodeTZS: "fcbe6a06b1fd49079a4965ca2b785e17",
  agentKeyTZS: "devtzs003",
  domainTZS: "1.tzs",
  merchantCodeKES: "9975333867cb454ebaa303cea9323a61",
  agentKeyKES: "devkes003",
  domainKES: "1.kes",
  merchantCodeNGN: "5011c511eebb49a699f3ee6b04500b10",
  agentKeyNGN: "devngn003",
  domainNGN: "1.ngn",
  merchantCodeBRL: "849c70918b5c480a8e01860908af1966",
  agentKeyBRL: "devbrl003",
  domainBRL: "1.brl",
  merchantCodeJPY: "708b1028dde74ed5afe2e2e9079e7b72",
  agentKeyJPY: "devjpy003",
  domainJPY: "1.jpy",
  playgameSetting: {
    "RMB": {
      merchantCode: "873e89f98d9c4523b36b34a22898595f",
      agentKey: "dev3001",
      domain: "dev001",
    },
    "THB": {
      merchantCode: "155f5a9dacc84f2b930c991ff123c3e2",
      agentKey: "thai003",
      domain: "1.thai",
    },
    "USD": {
      merchantCode: "219ad8443a404b80ba32188b8e130c60",
      agentKey: "deven03",
      domain: "1.en",
    },
    "VND": {
      merchantCode: "16d38ab8e70d4cfea7a257db90149c9d",
      agentKey: "devvi003",
      domain: "1.vi",
    },
    "NTD": {
      merchantCode: "369a796e269a4b499698111458d63e85",
      agentKey: "devtw003",
      domain: "1.tw",
    },
    "PHP": {
      merchantCode: "8b3cce5749264ef69af7423eb8c54a29",
      agentKey: "devphp003",
      domain: "1.php",
    },
    "ZMW": {
      merchantCode: "02701bd72c5a4c9cb8f387d7877a6137",
      agentKey: "devzmw003",
      domain: "1.zmw",
    },
    "TZS": {
      merchantCode: "fcbe6a06b1fd49079a4965ca2b785e17",
      agentKey: "devtzs003",
      domain: "1.tzs",
    },
    "KES": {
      merchantCode: "9975333867cb454ebaa303cea9323a61",
      agentKey: "devkes003",
      domain: "1.kes",
    },
    "NGN": {
      merchantCode: "5011c511eebb49a699f3ee6b04500b10",
      agentKey: "devngn003",
      domain: "1.ngn",
    },
    "BRL": {
      merchantCode: "849c70918b5c480a8e01860908af1966",
      agentKey: "devbrl003",
      domain: "1.brl",
    },
    "JPY": {
      merchantCode: "708b1028dde74ed5afe2e2e9079e7b72",
      agentKey: "devjpy003",
      domain: "1.jpy",
    },
    "MYR": {
      merchantCode: "2d759be4b48c4093b1a4a8151fd16aaf",
      agentKey: "devmyr003",
      domain: "1.myr",
    },
    "BDT": {
      merchantCode: "ab9547709a594ab2bbafb3acd8508cef",
      agentKey: "devbdt003",
      domain: "1.bdt",
    },
    "IDR": {
      merchantCode: "7b62ef710c7348c78fd868909341d321",
      agentKey: "devidr003",
      domain: "1.idr",
    },
    "KRW": {
      merchantCode: "f6612a2fff7d44b58943f5ada28f5c66",
      agentKey: "devkrw003",
      domain: "1.krw",
    },
    "MXN": {
      merchantCode: "e5217b29b39d46a8b4ce76b542410f73",
      agentKey: "devmxn003",
      domain: "1.mxn",
    },
    "ARS": {
      merchantCode: "d297165c875849fa837e1000dba7907e",
      agentKey: "devars003",
      domain: "1.ars",
    },
    "INR": {
      merchantCode: "a11995adcdce4d868dc6276f0ad91421",
      agentKey: "devinr003",
      domain: "1.inr",
    },
    "RUB": {
      merchantCode: "d5f5573799924cc38960400e9389309c",
      agentKey: "devrub003",
      domain: "1.rub",
    },
    "TRY": {
      merchantCode: "6f3b94b917934d50b9cd1a4254f1116c",
      agentKey: "devtry003",
      domain: "1.try",
    },
    "PKR": {
       merchantCode: "ae9cbb6c72d34a61b43aeaaad18fca5d",
      agentKey: "devpkr003",
      domain: "1.pkr",
    },
    "EGP": {
       merchantCode: "40550607d27745b1b6d7962d55fe21a0",
      agentKey: "devegp003",
      domain: "1.egp",
    },
    "ZAR": {
       merchantCode: "ed3d5cffdd28460285d3851d71539a10",
      agentKey: "devzar003",
      domain: "1.zar",
    },
    "NTA": {
       merchantCode: "1f083f5b68604a93bea263bc5463bc95",
      agentKey: "dev100ntd003",
      domain: "1.100ntd",
    },
    "NTB": {
       merchantCode: "a1717514968c459aa042d1b4ddaabd3e",
      agentKey: "dev10kntd003",
      domain: "1.10kntd",
    }
  },
}

// 跑prod環境
var localConfig = {
  gameAPI: "https://api.tjgame168.com/party/",
  serviceAPI: "https://api.tjgame168.com/service/",
  agentKey: "dev003",
  domain: "1.com",
  frontendAPI: "",
  lineUrl: "https://game1.ledu360.com/lines.json",
  merchantCode: "1a478d08998d4db58ac2d9a5b18b021e",
  gameWebUrl: "https://gameweb.tjgame168.com/",
  showGameList: true,
  envName: "localProd",
  currentLang: "zh-CN",
  currentCurrency: "RMB",
  merchantCodeCN: "1a478d08998d4db58ac2d9a5b18b021e",
  agentKeyCN: "dev003",
  domainCN: "1.com",
  merchantCodeTH: "6447e6b79f4a48569e10b201af4c095f",
  agentKeyTH: "thai003",
  domainTH: "1.thai",
  merchantCodeEN: "17190574090544b2a2f6844eb826879f",
  agentKeyEN: "deven03",
  domainEN: "1.en",
  merchantCodeVI: "14e1bb3d50004b6ea46e5a03f2d261b8",
  agentKeyVI: "devvi003",
  domainVI: "1.vi",
  merchantCodeTW: "5fd37c68bcc74c72b4039389255b44f7",
  agentKeyTW: "devtw003",
  domainTW: "1.tw",
  merchantCodePHP: "8f64fd83a98244acb3c02ca22cc64b6d",
  agentKeyPHP: "devphp003",
  domainPHP: "1.php",
  merchantCodeZMW: "1182fea4b54c4a8da298bb19f860337f",
  agentKeyZMW: "devzmw003",
  domainZMW: "1.zmw",
  merchantCodeTZS: "8e3369a1160c404bb7441cd187b80681",
  agentKeyTZS: "devtzs003",
  domainTZS: "1.tzs",
  merchantCodeKES: "870a6900cb7f4c0ba9dd651b6c646d76",
  agentKeyKES: "devkes003",
  domainKES: "1.kes",
  merchantCodeNGN: "d8f6f220c553479e8327f76bb265f339",
  agentKeyNGN: "devngn003",
  domainNGN: "1.ngn",
  merchantCodeBRL: "af119ef0a71a4897b643a42954adf601",
  agentKeyBRL: "devbrl003",
  domainBRL: "1.brl",
  merchantCodeJPY: "30516cf0fce445d0969530fe7183e39f",
  agentKeyJPY: "devjpy003",
  domainJPY: "1.jpy",
  playgameSetting: {
    "RMB": {
      merchantCode: "1a478d08998d4db58ac2d9a5b18b021e",
      agentKey: "dev003",
      domain: "1.com",
    },
    "THB": {
      merchantCode: "6447e6b79f4a48569e10b201af4c095f",
      agentKey: "thai003",
      domain: "1.thai",
    },
    "USD": {
      merchantCode: "17190574090544b2a2f6844eb826879f",
      agentKey: "deven03",
      domain: "1.en",
    },
    "VND": {
      merchantCode: "14e1bb3d50004b6ea46e5a03f2d261b8",
      agentKey: "devvi003",
      domain: "1.vi",
    },
    "NTD": {
      merchantCode: "5fd37c68bcc74c72b4039389255b44f7",
      agentKey: "devtw003",
      domain: "1.tw",
    },
    "PHP": {
      merchantCode: "8f64fd83a98244acb3c02ca22cc64b6d",
      agentKey: "devphp003",
      domain: "1.php",
    },
    "ZMW": {
      merchantCode: "1182fea4b54c4a8da298bb19f860337f",
      agentKey: "devzmw003",
      domain: "1.zmw",
    },
    "TZS": {
      merchantCode: "8e3369a1160c404bb7441cd187b80681",
      agentKey: "devtzs003",
      domain: "1.tzs",
    },
    "KES": {
      merchantCode: "870a6900cb7f4c0ba9dd651b6c646d76",
      agentKey: "devkes003",
      domain: "1.kes",
    },
    "NGN": {
      merchantCode: "d8f6f220c553479e8327f76bb265f339",
      agentKey: "devngn003",
      domain: "1.ngn",
    },
    "BRL": {
      merchantCode: "af119ef0a71a4897b643a42954adf601",
      agentKey: "devbrl003",
      domain: "1.brl",
    },
    "JPY": {
      merchantCode: "30516cf0fce445d0969530fe7183e39f",
      agentKey: "devjpy003",
      domain: "1.jpy",
    },
    "MYR": {
      merchantCode: "acc2018be46849da9998417783708d69",
      agentKey: "devmyr003",
      domain: "1.myr",
    },
    "BDT": {
      merchantCode: "f4b3ad6482074f1ea788798452838df4",
      agentKey: "devbdt003",
      domain: "1.bdt",
    },
    "IDR": {
      merchantCode: "4cc0b38bb46e4d3183e5b65d956029e7",
      agentKey: "devidr003",
      domain: "1.idr",
    },
    "KRW": {
      merchantCode: "b9ef6ae9d60148e2b1877c6867790a91",
      agentKey: "devkrw003",
      domain: "1.krw",
    },
    "MXN": {
      merchantCode: "a8c5868dd54f4673a09084e856607d7f",
      agentKey: "devmxn003",
      domain: "1.mxn",
    },
    "ARS": {
      merchantCode: "ab992fe595f64250a8b7a22a1999e470",
      agentKey: "devars003",
      domain: "1.ars",
    },
    "INR": {
      merchantCode: "9153b747c8c64262b256fcf87a25f24f",
      agentKey: "devinr003",
      domain: "1.inr",
    },
    "RUB": {
      merchantCode: "1a4c516e37844286813935c94d7d1c50",
      agentKey: "devrub003",
      domain: "1.rub",
    },
    "TRY": {
      merchantCode: "8dd02d367ce54699970b092ad0c9c8cb",
      agentKey: "devtry003",
      domain: "1.try",
    },
    "PKR": {
       merchantCode: "1fedaa072e1b469aafaf36d21f253360",
      agentKey: "devpkr003",
      domain: "1.pkr",
    },
    "EGP": {
       merchantCode: "14b3afb18a65481a8f5dcd09142a054d",
      agentKey: "devegp003",
      domain: "1.egp",
    },
    "ZAR": {
       merchantCode: "498daa5116e642888114846beb777440",
      agentKey: "devzar003",
      domain: "1.zar",
    },
    "NTA": {
       merchantCode: "ad4108daf5b94fc1a8189679a60995bd",
      agentKey: "dev100ntd003",
      domain: "1.100ntd",
    },
    "NTB": {
       merchantCode: "8e390a697ee146f0b26114e02fee04c2",
      agentKey: "dev10kntd003",
      domain: "1.10kntd",
    }
  },
}


var prodConfig = {
  gameAPI: "https://api.tjgame168.com/party/",
  serviceAPI: "https://api.tjgame168.com/service/",
  agentKey: "dev003",
  domain: "1.com",
  frontendAPI: "",
  lineUrl: "https://game1.ledu360.com/lines.json",
  // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
  merchantCode: "1a478d08998d4db58ac2d9a5b18b021e",
  gameWebUrl: "https://gameweb.tjgame168.com/",
  showGameList: false,
  envName: "prod",
  currentLang: "zh-CN",
  currentCurrency: "RMB",
  merchantCodeCN: "1a478d08998d4db58ac2d9a5b18b021e",
  agentKeyCN: "dev003",
  domainCN: "1.com",
  merchantCodeTH: "6447e6b79f4a48569e10b201af4c095f",
  agentKeyTH: "thai003",
  domainTH: "1.thai",
  merchantCodeEN: "17190574090544b2a2f6844eb826879f",
  agentKeyEN: "deven03",
  domainEN: "1.en",
  merchantCodeVI: "14e1bb3d50004b6ea46e5a03f2d261b8",
  agentKeyVI: "devvi003",
  domainVI: "1.vi",
  merchantCodeTW: "5fd37c68bcc74c72b4039389255b44f7",
  agentKeyTW: "devtw003",
  domainTW: "1.tw",
  merchantCodePHP: "8f64fd83a98244acb3c02ca22cc64b6d",
  agentKeyPHP: "devphp003",
  domainPHP: "1.php",
  merchantCodeZMW: "1182fea4b54c4a8da298bb19f860337f",
  agentKeyZMW: "devzmw003",
  domainZMW: "1.zmw",
  merchantCodeTZS: "8e3369a1160c404bb7441cd187b80681",
  agentKeyTZS: "devtzs003",
  domainTZS: "1.tzs",
  merchantCodeKES: "870a6900cb7f4c0ba9dd651b6c646d76",
  agentKeyKES: "devkes003",
  domainKES: "1.kes",
  merchantCodeNGN: "d8f6f220c553479e8327f76bb265f339",
  agentKeyNGN: "devngn003",
  domainNGN: "1.ngn",
  merchantCodeBRL: "af119ef0a71a4897b643a42954adf601",
  agentKeyBRL: "devbrl003",
  domainBRL: "1.brl",
  merchantCodeJPY: "30516cf0fce445d0969530fe7183e39f",
  agentKeyJPY: "devjpy003",
  domainJPY: "1.jpy",
  playgameSetting: {
    "RMB": {
      merchantCode: "1a478d08998d4db58ac2d9a5b18b021e",
      agentKey: "dev003",
      domain: "1.com",
    },
    "THB": {
      merchantCode: "6447e6b79f4a48569e10b201af4c095f",
      agentKey: "thai003",
      domain: "1.thai",
    },
    "USD": {
      merchantCode: "17190574090544b2a2f6844eb826879f",
      agentKey: "deven03",
      domain: "1.en",
    },
    "VND": {
      merchantCode: "14e1bb3d50004b6ea46e5a03f2d261b8",
      agentKey: "devvi003",
      domain: "1.vi",
    },
    "NTD": {
      merchantCode: "5fd37c68bcc74c72b4039389255b44f7",
      agentKey: "devtw003",
      domain: "1.tw",
    },
    "PHP": {
      merchantCode: "8f64fd83a98244acb3c02ca22cc64b6d",
      agentKey: "devphp003",
      domain: "1.php",
    },
    "ZMW": {
      merchantCode: "1182fea4b54c4a8da298bb19f860337f",
      agentKey: "devzmw003",
      domain: "1.zmw",
    },
    "TZS": {
      merchantCode: "8e3369a1160c404bb7441cd187b80681",
      agentKey: "devtzs003",
      domain: "1.tzs",
    },
    "KES": {
      merchantCode: "870a6900cb7f4c0ba9dd651b6c646d76",
      agentKey: "devkes003",
      domain: "1.kes",
    },
    "NGN": {
      merchantCode: "d8f6f220c553479e8327f76bb265f339",
      agentKey: "devngn003",
      domain: "1.ngn",
    },
    "BRL": {
      merchantCode: "af119ef0a71a4897b643a42954adf601",
      agentKey: "devbrl003",
      domain: "1.brl",
    },
    "JPY": {
      merchantCode: "30516cf0fce445d0969530fe7183e39f",
      agentKey: "devjpy003",
      domain: "1.jpy",
    },
    "MYR": {
      merchantCode: "acc2018be46849da9998417783708d69",
      agentKey: "devmyr003",
      domain: "1.myr",
    },
    "BDT": {
      merchantCode: "f4b3ad6482074f1ea788798452838df4",
      agentKey: "devbdt003",
      domain: "1.bdt",
    },
    "IDR": {
      merchantCode: "4cc0b38bb46e4d3183e5b65d956029e7",
      agentKey: "devidr003",
      domain: "1.idr",
    },
    "KRW": {
      merchantCode: "b9ef6ae9d60148e2b1877c6867790a91",
      agentKey: "devkrw003",
      domain: "1.krw",
    },
    "MXN": {
      merchantCode: "a8c5868dd54f4673a09084e856607d7f",
      agentKey: "devmxn003",
      domain: "1.mxn",
    },
    "ARS": {
      merchantCode: "ab992fe595f64250a8b7a22a1999e470",
      agentKey: "devars003",
      domain: "1.ars",
    },
    "INR": {
      merchantCode: "9153b747c8c64262b256fcf87a25f24f",
      agentKey: "devinr003",
      domain: "1.inr",
    },
    "RUB": {
      merchantCode: "1a4c516e37844286813935c94d7d1c50",
      agentKey: "devrub003",
      domain: "1.rub",
    },
    "TRY": {
      merchantCode: "8dd02d367ce54699970b092ad0c9c8cb",
      agentKey: "devtry003",
      domain: "1.try",
    },
    "PKR": {
       merchantCode: "1fedaa072e1b469aafaf36d21f253360",
      agentKey: "devpkr003",
      domain: "1.pkr",
    },
    "EGP": {
       merchantCode: "14b3afb18a65481a8f5dcd09142a054d",
      agentKey: "devegp003",
      domain: "1.egp",
    },
    "ZAR": {
       merchantCode: "498daa5116e642888114846beb777440",
      agentKey: "devzar003",
      domain: "1.zar",
    },
    "NTA": {
       merchantCode: "ad4108daf5b94fc1a8189679a60995bd",
      agentKey: "dev100ntd003",
      domain: "1.100ntd",
    },
    "NTB": {
       merchantCode: "8e390a697ee146f0b26114e02fee04c2",
      agentKey: "dev10kntd003",
      domain: "1.10kntd",
    }
  },
}

var appConfig = {
  gameAPI: "http://10.209.1.211:8080/party/",
  serviceAPI: "http://10.209.1.211:8080/service/",
  agentKey: "dcagent",
  domain: "1.dc",
  frontendAPI: "",
  lineUrl: "http://game.filipinotongits.com/lines.json",
  // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
  merchantCode: "1e396014cdac4a3b855431890f51ccc6",
  gameWebUrl: "http://gameweb.filipinotongits.com/",
  showGameList: true,
  envName: "app",
  currentLang: "en",
  currentCurrency: "DCP",
  playgameSetting: {
    "DCP": {
      merchantCode: "1e396014cdac4a3b855431890f51ccc6",
      agentKey: "dcagent",
      domain: "1.dc",
    },
  },

}

const testConfig ={
  gameAPI: "https://testgameapi.tiangeo.com/party/",
  serviceAPI: "https://testfrontendapi.tiangeo.com/service/",
  agentKey: "dev003",
  domain: "1.com",
  frontendAPI: "",
  lineUrl: "https://testline.tiangeo.com/lines_test.json",
  // authorizedKey: "88de294dbbb54e9297aaf6f6100f6190",
  merchantCode: "19fac377b23049ba87fa010382a084d8",
  gameWebUrl: "https://testgameweb.tiangeo.com/",
  showGameList: true,
  envName: "test",
  currentLang: "zh-CN",
  currentCurrency: "RMB",
  merchantCodeCN: "19fac377b23049ba87fa010382a084d8",
  agentKeyCN: "dev003",
  domainCN: "1.com",
  merchantCodeTH: "49f141628e994baf85c8b735252b8485",
  agentKeyTH: "thai003",
  domainTH: "1.thai",
  merchantCodeEN: "79ad9956ea3a461ca2c8fcd802e0f95f",
  agentKeyEN: "deven03",
  domainEN: "1.en",
  merchantCodeVI: "34b0fb7d568a4116bffe0a18c30095e6",
  agentKeyVI: "devvi003",
  domainVI: "1.vi",
  merchantCodeTW: "0f51b508314e4d72b360b24b43d35e13",
  agentKeyTW: "devtw003",
  domainTW: "1.tw",
  merchantCodePHP: "1b1bfe115ccd4b429c98a1c39a8d1724",
  agentKeyPHP: "devphp003",
  domainPHP: "1.php",
  merchantCodeZMW: "e4cf027b5d99464681cfbceba20f8361",
  agentKeyZMW: "devzmw003",
  domainZMW: "1.zmw",
  merchantCodeTZS: "e6d79edc20304729b04266aadb31b258",
  agentKeyTZS: "devtzs003",
  domainTZS: "1.tzs",
  merchantCodeKES: "33f5a43c13ea4d849a82a3ec33fbbf46",
  agentKeyKES: "devkes003",
  domainKES: "1.kes",
  merchantCodeNGN: "06c63cc058a7444f9e0f7177dce1146e",
  agentKeyNGN: "devngn003",
  domainNGN: "1.ngn",
  merchantCodeBRL: "7657c4dcb6a645ea849a6e8957154a64",
  agentKeyBRL: "devbrl003",
  domainBRL: "1.brl",
  merchantCodeJPY: "dbd80a115e4c4a5c87f09c0dd1e676d7",
  agentKeyJPY: "devjpy003",
  domainJPY: "1.jpy",
  playgameSetting: {
    "RMB": {
      merchantCode: "19fac377b23049ba87fa010382a084d8",
      agentKey: "dev003",
      domain: "1.com",
    },
    "THB": {
      merchantCode: "49f141628e994baf85c8b735252b8485",
      agentKey: "thai003",
      domain: "1.thai",
    },
    "USD": {
      merchantCode: "79ad9956ea3a461ca2c8fcd802e0f95f",
      agentKey: "deven03",
      domain: "1.en",
    },
    "VND": {
      merchantCode: "34b0fb7d568a4116bffe0a18c30095e6",
      agentKey: "devvi003",
      domain: "1.vi",
    },
    "NTD": {
      merchantCode: "0f51b508314e4d72b360b24b43d35e13",
      agentKey: "devtw003",
      domain: "1.tw",
    },
    "PHP": {
      merchantCode: "1b1bfe115ccd4b429c98a1c39a8d1724",
      agentKey: "devphp003",
      domain: "1.php",
    },
    "ZMW": {
      merchantCode: "e4cf027b5d99464681cfbceba20f8361",
      agentKey: "devzmw003",
      domain: "1.zmw",
    },
    "TZS": {
      merchantCode: "e6d79edc20304729b04266aadb31b258",
      agentKey: "devtzs003",
      domain: "1.tzs",
    },
    "KES": {
      merchantCode: "33f5a43c13ea4d849a82a3ec33fbbf46",
      agentKey: "devkes003",
      domain: "1.kes",
    },
    "NGN": {
      merchantCode: "06c63cc058a7444f9e0f7177dce1146e",
      agentKey: "devngn003",
      domain: "1.ngn",
    },
    "BRL": {
      merchantCode: "7657c4dcb6a645ea849a6e8957154a64",
      agentKey: "devbrl003",
      domain: "1.brl",
    },
    "JPY": {
      merchantCode: "dbd80a115e4c4a5c87f09c0dd1e676d7",
      agentKey: "devjpy003",
      domain: "1.jpy",
    },
    "MYR": {
      merchantCode: "c3d5362b5c6344779adf268e0df3df48",
      agentKey: "devmyr003",
      domain: "1.myr",
    },
    "BDT": {
      merchantCode: "5ec71e663dcb420e894b61ce499a6ec6",
      agentKey: "devbdt003",
      domain: "1.bdt",
    },
    "IDR": {
      merchantCode: "7adb0834191b46c193ff39d946298a81",
      agentKey: "devidr003",
      domain: "1.idr",
    },
    "KRW": {
      merchantCode: "8d5a815745944cd48c4c811b7777126a",
      agentKey: "devkrw003",
      domain: "1.krw",
    },
    "MXN": {
      merchantCode: "9f24f893855d4a9ba5f62bdde3018e6a",
      agentKey: "devmxn003",
      domain: "1.mxn",
    },
    "ARS": {
      merchantCode: "957745a38de54723acd6d758b604cc2d",
      agentKey: "devars003",
      domain: "1.ars",
    },
    "INR": {
      merchantCode: "33587333db2f4d1bb8daf23d66871489",
      agentKey: "devinr003",
      domain: "1.inr",
    },
    "RUB": {
      merchantCode: "6f52c5f0c4704a6993bf596ca8dda72d",
      agentKey: "devrub003",
      domain: "1.rub",
    },
    "TRY": {
      merchantCode: "9d7949406e5a4dbfbe0d0d305148adca",
      agentKey: "devtry003",
      domain: "1.try",
    },
    "HKD": {
      merchantCode: "3072594b28eb4ff0bbde11ebeda72477",
      agentKey: "devhkd003",
      domain: "1.hkd",
    },
  },

}

if (process.env.NODE_ENV == "dev") {
  configData = devConfig;
}
if (process.env.NODE_ENV == "qc") {
  configData = qcConfig;
}
if (process.env.NODE_ENV == "test") {
  configData = testConfig;
}
if (process.env.NODE_ENV == "demosite") {
  configData = demositeConfig;
  if(window.location.hostname === 'staging.tiangeo168.com') {
    configData.lineUrl = tiangeo168LinesUrl;
  }
}
if (process.env.NODE_ENV == "local") {
  configData = localConfig;
}

if (process.env.NODE_ENV == "stress") {
  configData = stressConfig;
}

if (process.env.NODE_ENV == "prod") {
  configData = prodConfig;
}

if (process.env.NODE_ENV == "staging") {
  configData = stagingConfig;
}

if (process.env.NODE_ENV == "app") {
  configData = appConfig;
}

export {
  configData
}



// WEBPACK FOOTER //
// ./src/config/config.js